import React from 'react'
import moment from 'moment'
import { Row, Col, Table, Typography, Tooltip } from 'antd'

import 'moment/locale/es'

import { useFirebase } from '../firebaseContext'
import { useRedux } from '../redux'

const { Title } = Typography

moment.locale('es')

const columns = [
  {
    title: 'Nombre',
    dataIndex: 'first_name',
    key: 'first_name',
  },
  {
    title: 'Apellido',
    dataIndex: 'last_name',
    key: 'last_name',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Teléfono',
    dataIndex: 'phone_number',
    key: 'phone_number',
  },
  {
    title: 'Creado',
    dataIndex: 'created',
    key: 'created',
    responsive: ['xl'],
    ellipsis: {
      showTitle: false,
    },
    render: created => (
      <Tooltip placement="topLeft" title={`${moment(created.toDate()).format('DD MMMM YYYY, h:mm a')} (${moment(created.toDate()).fromNow()})`}>
        {`${moment(created.toDate()).format('DD MMMM YYYY, h:mm a')} (${moment(created.toDate()).fromNow()})`}
      </Tooltip>
    )
  }
]

export default function Appointments() {
  const [items, setItems] = React.useState([])
  const firebase = useFirebase()
  const actions = useRedux()

  React.useEffect(() => {
    actions.setAppLoading(true)
    const ref = firebase.getCollectionRef('users').orderBy('created', 'desc').limit(40)
    const unsuscribe = ref.onSnapshot(async snap => {
      let array = []
      actions.setAppLoading(true)
      await Promise.all(snap.docs.map(async doc => {
        const data = doc.data()
        array.push(data)
      }))
      setItems(array)
      actions.setAppLoading(false)
    })
    return () => {
      unsuscribe()
    }
  }, [])

  return (
    <div>
      <Title level={2}>Usuarios</Title>
      <Row>
        <Col span={24}>
          <Table dataSource={items} columns={columns} pagination={false} />
        </Col>
      </Row>
    </div>
  )
}
